import { ConsumableGroup } from '../interfaces/dtos/ConsumableGroup';
import { IProductDisplayMenu } from '../interfaces/dtos/IProductDisplayMenu';
import { store } from '../redux/configure-store';
import { PluMenuActions } from '../redux/reducers/plu-menu-reducer';
import { ConsumerGroupConverter } from '../converters/consumer-group-converter';
import XLRLogger from './logger';

export const createProductDisplayMenu = async (menuData: ConsumableGroup): Promise<void> => {
  try {
    const pluMenu = menuData.consumableSubGroups?.map(
      (subGroup, index): IProductDisplayMenu => {
        return ConsumerGroupConverter().convertMenu(subGroup, index);
      },
    );
    if (pluMenu) {
      store.dispatch(PluMenuActions.setProductDisplayMenus(pluMenu));
    }
  } catch {
    XLRLogger.error({
      message: 'Product Display Menu not created.',
      source: 'create-product-display-menu.ts',
    });
  }
};
